export interface LineChartDatum {
  x: number;
  label: string;
  tooltipLabel?: string | undefined;
  value: number;
}

export enum LineChartAxisSide {
  Left = 'left',
  Right = 'right',
}

export interface LineChartAxisLabel {
  label: string;
  color: string;
}

export interface LineChartAxis {
  id: string;
  label: string;
  color: string;
  side: LineChartAxisSide;
  labels?: LineChartAxisLabel[] | undefined;
  axisValueFormatter?: ((value: number) => string) | undefined;
  valueFormatter?: ((value: number) => string) | undefined;
}

export interface LineChartSeries {
  id: string;
  label: string;
  color: string;
  data: LineChartDatum[];
  dashed?: boolean | undefined;
  legendGroupId?: string | undefined;
  axisId?: string | undefined;
}

export interface ResponsiveLineChartProps {
  ariaLabel: string;
  series: LineChartSeries[];
  defaultHiddenSeriesIds?: readonly string[] | undefined;
  valueFormatter?: ((value: number) => string) | undefined;
  emptyMessage?: string | undefined;
  axes?: LineChartAxis[] | undefined;
  /** Plot height in px, axes included (default 300). */
  height?: number | undefined;
}
